import { Stack } from '@mui/material';
import { anchorRef, bindTrigger } from 'material-ui-popup-state/hooks';
import Popover from '@mui/material/Popover';

import {
  Button,
  FilterButton,
  SearchForm,
  TableContainer,
  TableHeader,
} from '@occc-app/design-system';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { Table } from '@occc/ui-design-system';

import { headers } from './allow-list.headers';
import { UpsertPhoneNumberModalContainer } from './create-phone-number-modal/create-phone-number.modal-container';
import { useAllowListTableContainer } from './hooks/use-allow-list-table.container.hook';
import { TableFilterContainer } from './table-filter/table-filter.container';

type AllowListTableContainerProps = {
  tableTitle: string;
};

export const AllowListTableContainer = ({ tableTitle }: AllowListTableContainerProps) => {
  const {
    setSearch,
    search,
    onAddAllowListPhoneNumberClick,
    rows,
    paginationProps,
    loading,
    error,
    isUserPermittedToAddPhoneNumberToAllowList,
    isUpsertNumberModalVisible,
    isCreateMode,
    toggleUpsertAllowListPhoneNumberModal,
    phoneNumberFragment,
    filter,
    popupState,
    onFilterFormSubmit,
    popoverProps,
    onFilterFormReset,
    isFilterSelected,
  } = useAllowListTableContainer();

  return (
    <TableContainer>
      <TableHeader
        title={tableTitle}
        actions={
          <Stack direction='row' spacing={1}>
            <SearchForm
              onSubmit={({ search }) => setSearch(search)}
              initialValues={{ search: search }}
            />
            <FilterButton
              {...bindTrigger(popupState)}
              ref={anchorRef(popupState)}
              sx={{ ml: null, mr: null }}
              badgeSx={{
                '& .MuiBadge-dot': { top: '10px', right: '6px' },
              }}
              showBadge={isFilterSelected}
            />
            <Button variant='contained' onClick={onAddAllowListPhoneNumberClick}>
              Add Number
            </Button>
          </Stack>
        }
      />

      <Table
        rows={rows}
        paginationProps={paginationProps}
        headers={headers}
        loading={loading}
        error={error}
      />

      {isUserPermittedToAddPhoneNumberToAllowList && isUpsertNumberModalVisible && (
        <UpsertPhoneNumberModalContainer
          isCreateMode={isCreateMode}
          isOpen={isUpsertNumberModalVisible}
          onClose={toggleUpsertAllowListPhoneNumberModal}
          existingEntity={phoneNumberFragment}
        />
      )}

      <Popover
        {...popoverProps}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        keepMounted
        sx={{
          '.MuiPopover-paper': {
            maxWidth: 460,
            minWidth: 300,
          },
        }}
      >
        <TableFilterContainer
          onSubmit={onFilterFormSubmit}
          onReset={onFilterFormReset}
          initialValues={filter}
        />
      </Popover>
    </TableContainer>
  );
};
